module.exports = __webpack_public_path__ + "img/voice-thumb9.f571a90.jpg";